import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function Hero() {
  const handlePurchase = () => {
    window.location.href = 'https://miguiaclara.com/cart/50831423799586:1';
  };
  return <div className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-gradient-to-b from-brand-bg to-brand-light/50 pt-10 pb-16 px-4" data-id="element-34">
      <div className="max-w-4xl mx-auto w-full flex flex-col items-center gap-12" data-id="element-35">
        {/* Text Content - Now First */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center w-full" data-id="element-36">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-accent/20 text-brand-primary text-sm font-semibold mb-6 tracking-wide uppercase" data-id="element-37">
            Menopausia Sin Fogatas
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium leading-tight text-brand-text mb-6" data-id="element-38">
            No estás loca: <br data-id="element-39" />
            <span className="italic text-brand-primary" data-id="element-40">
              estás en modo alarma.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-41">
            10 minutos a la mañana. 10 a la noche. <br data-id="element-42" />Y tu cuerpo deja de
            gritar.
          </p>

          <div className="flex justify-center" data-id="element-43">
            <Button size="lg" onClick={handlePurchase} data-id="element-44">
              Quiero mi plan de 21 días
            </Button>
          </div>

          <p className="mt-4 text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-45">
            <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-46"></span>
            Descarga inmediata PDF
          </p>
        </motion.div>

        {/* Image - Now Second */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative flex justify-center" data-id="element-47">
          <div className="relative w-[280px] md:w-[400px] aspect-[3/4]" data-id="element-48">
            <div className="absolute inset-0 bg-brand-primary/10 rounded-2xl transform rotate-3 translate-x-4 translate-y-4" data-id="element-49"></div>
            <img src="https://cdn.magicpatterns.com/uploads/3TohiJKhypNuohhxEix2za/hf_20260122_214131_e30f5551-5524-402b-a098-49dab5553046.png" alt="Biohacking Exprés Ebook Cover" className="relative z-10 w-full h-full object-cover rounded-2xl shadow-2xl" data-id="element-50" />
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center text-brand-primary/50" data-id="element-51">
        <span className="text-xs uppercase tracking-widest mb-2" data-id="element-52">
          Descubre más
        </span>
        <ArrowDown className="w-5 h-5 animate-bounce" data-id="element-53" />
      </motion.div>
    </div>;
}